import { storageService } from "../../services/StorageService.js";
// mutation
export function CLEAR_USER_SETTINGS(state){
    storageService.clear();
    state.user_stored={};
    state.user_schools=[];
}